const freeTrialFuncionalitiesEnum = {
    'FINANCIAL_GOALS':{
        'name':'FINANCIAL_GOALS',
        'date':'31/10'
    }
}

export default  freeTrialFuncionalitiesEnum